import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '@state/session/session.service';
import { SessionQuery } from '@state/session/session.query';
import { environment } from '../../../../environments/environment';

@Injectable()
export class RefreshInterceptor implements HttpInterceptor {

    constructor(private sessionQuery: SessionQuery, private sessionService: SessionService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const refreshInterval = this.sessionQuery.getValue().refreshInterval;
        clearInterval(refreshInterval);

        const interval = setInterval(() => this.sessionService.refreshConnection().subscribe(), environment.refreshInterval);
        this.sessionService.update({ refreshInterval: interval });

        return next.handle(request);
    }
}
